/**
 * Numbering follows the boxes on the ICS 201-CG form, as printed by
 * `services/coms/src/routes/Forms/ICS_CG/forms/ICS201CG.ts`.
 *
 * Boxes 1 to 4 are read-only on the card; 5 onwards are the live Initial
 * Response editors, each of which saves through its own path rather than
 * through the card.
 *
 * The printed sheet repeats a Prepared by block under each section — boxes 6,
 * 8, 10, 12, 14 and 16 — but the fillable template carries only one signature
 * field group, so the card shows one block covering all of them.
 */
export const ICS201_BOX_LABELS = {
  incidentName: '1. Incident Name:',
  incidentLocation: '2. Incident Location:',
  dateTimeInitiated: '3. Date / Time Initiated:',
  mapSketch: '4. Map/Sketch:',
  currentSituation: '5. Current Situation:',
  objectivesAndActions:
    '7. Initial Response Objectives, Current Actions, Planned Actions:',
  currentOrganization: '9. Current Organization:',
  resourceSummary: '11. Resources Summary:',
  safetyAndHazmat:
    '13 & 15. Safety Analysis and Hazardous Material (HAZMAT) Assessment:',
  preparedBy: '6, 8, 10, 12, 14 & 16. Prepared by:',
} as const;

export const ICS201_INCIDENT_NAME_HINT =
  'This box is read-only. It is filled from the incident name.';

/** Mirrors `resolveOperationalPeriodValues`, which the PDF export uses. */
export const ICS201_INCIDENT_LOCATION_HINT =
  'This box is read-only. It is filled from the incident location, falling back to the address set when the incident was created.';

/**
 * Box 3 is the moment the incident began, not an operational period window. The
 * server's period-0 branch reads it from `incident_created`, and this box shows
 * the same value.
 */
export const ICS201_DATE_TIME_INITIATED_HINT =
  'This box is read-only. During initial response it is filled from the time the incident was created, which is what the exported form prints.';

export const ICS201_MAP_SKETCH_HINT =
  'Compose layers and frame the map in this box, then Take Snapshot for ICS-201 Export. Use Go to Primary Map for full Map Layers editing (features, symbology, and catalog). Generate / Export PDF captures the same framed view for Box 4.';
